module.exports = __webpack_public_path__ + "static/img/D4105.dbe31372.png";